import { useTenderActionError } from "../../../../../../../hooks/useTenderActionError";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Aviation } from "../../../../../../../services";
import CustomButton from "../../../../../../custom/custom-button/CustomButton";
import CloseIconNew from "../../../../../../shared/icons/CloseIconNew";
import style from "./ExpeditorRevokeBidModal.module.scss";

const ExpeditorRevokeBidModal = ({ onRefreshOrder, isOpen, onClose, bid, order, onSuccess }) => {
  const { t } = useTranslation();
  const { requestErrorDisplay } = useTenderActionError(order, { onRefreshOrder });
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await Aviation.deleteSuggestedPrice(bid.id);
      toast.success(t("orderInfoExpeditor.bid.bidRevoked"));
      onSuccess?.();
    } catch (error) {
      console.error(error);
      await requestErrorDisplay(error, t, "orderInfoExpeditor.bid.revokeBidError");
    } finally {
      setIsLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className={style.overlay} onClick={onClose} data-portal-modal="true">
      <div className={style.modal} onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className={style.close_btn}
          onClick={onClose}
          aria-label={t("orderInfoExpeditor.assignDriverModal.close")}
        >
          <CloseIconNew width="24" height="24" fill="#212121" />
        </button>
        <div className={style.body}>
          <p className={style.title}>{t("orderInfoExpeditor.bid.revokeBid")}</p>
          <p className={style.description}>{t("orderInfoExpeditor.bid.revokeBidConfirm")}</p>
        </div>
        <div className={style.footer}>
          <div className={style.footer_btn}>
            <CustomButton
              text={t("orderInfoExpeditor.suggestPrice.no")}
              isNavy
              isWhite
              onClick={onClose}
              disabled={isLoading}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.footer_btn}>
            <CustomButton
              text={t("orderInfoExpeditor.suggestPrice.yes")}
              isNavy
              onClick={handleConfirm}
              isLoading={isLoading}
              disabled={isLoading}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ExpeditorRevokeBidModal;

